import { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';

import { IRouterProps } from '@interfaces/App.interface';
import { IConfigComponent, CReadingType, CStatusIndicator } from '@ts/ui-models';
import {
  IDataGridConfig,
  generateGlobalColumns,
  generateBasicColumn,
  generateBooleanColumn,
  generateEntityColumn,
  generateNumberColumn,
} from '@ts/storybook';

interface IIndicatorTypesProps extends IRouterProps {
  configComponent?: IConfigComponent;
  inheritedProps?: any;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'indicatorTypes',
  aclId: 'indicatorType',
  entity: 'indicator',
  fetchURL: '/api/paginated/indicators',
  crudURL: '/api/indicator',
  mainClass: CStatusIndicator,
};

const StatusIndicators = (props: IIndicatorTypesProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };
  const getColumns = useMemo((): GridColDef<any>[] => {
    const globalCells = generateGlobalColumns({ ...props, configComponent });
    return [
      globalCells.id(),
      globalCells.name(),
      generateBasicColumn({ field: 'type' }, { field: 'type' }),
      generateBooleanColumn({ field: 'updateManual', headerName: 'Update manual' }, { field: 'manual', tEntity: 'update' }),
      generateBooleanColumn({ field: 'updateLive', headerName: 'Update live' }, { field: 'live', tEntity: 'update' }),
      generateEntityColumn(
        { field: 'readingType', headerName: 'Reading type' },
        { field: 'readingType', mainClass: CReadingType },
        { inheritedProps: { ...inheritedProps, isEntitySelector: true } }
      ),
      generateBasicColumn({ field: 'unitName', headerName: 'Unit' }, { field: 'unit.name' }),
      generateNumberColumn({ field: 'iconRules', headerName: 'Icon rules', dataFormat: v => v.length }, { field: 'iconRules' }),
      generateBooleanColumn({ field: 'isSystem', headerName: 'System indicator' }, { field: 'isSystem' }),
    ];
  }, [props, configComponent]);
  //Available indicators
  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      customDeleteModal={{
        message: [
          'Doing so will affect event generation rules, event types workflows, and item status templates.',
          ' ',
          <b>This action cannot be undone.</b>,
        ],
      }}
      inheritedProps={inheritedProps}
      //restrictionEdit={{ field: 'isSystem', value: true }}
      //restrictionDelete={{ field: 'isSystem', value: true }}
    />
  );
};

export default StatusIndicators;
